import {select, put, call, takeLatest} from 'redux-saga/effects'
import { getFormValues } from 'redux-form';

import actionTypes from '../../constants/actions/analisisExtracciones/contajeMaquinas'
import {guardarResultadoSistemaAnalisis} from '../../actions/analisisExtracciones/analisisExtracciones'
import {guardarResultadoSistemaAnalisisControlMorfologico} from '../../actions/planSanitario/controlCalidad/controlMorfologico'
import {openModalContajeMaquinasSuccess, closeModalContajeMaquinasSuccess} from '../../actions/analisisExtracciones/contajeMaquinas'
import getTeclasContajeService from '../../services/analisisExtracciones/getTeclasContaje'
import {yesNoModal as yesNoModalSaga} from '../modal/yesNoModal'
import {tipoAnalisisControlMorfologicoSeguimiento as tipo} from '../../constants/comun'

export function * openModalContajeMaquinas ({tipoAnalisis, isSeguimiento}) {
  try {
    const state = yield select(state => state)
    let {
      volumen, idVerraco
    } = !isSeguimiento ? yield getFormValues('formAnalisisExtraccion')(state) : {}

    if (!isSeguimiento && !idVerraco) {
      yield call(yesNoModalSaga, {
        modalType: 'verracoRequerido'
      })
    } else if (!isSeguimiento && (!volumen || parseFloat(volumen) <= 0)) {
      yield call(yesNoModalSaga, {
        modalType: 'volumenRequerido'
      })
    } else {
      let teclasContaje = yield call(getTeclasContajeService)
      teclasContaje = {
        acrosomasDannados: {
          incrementarKey: teclasContaje.sumarAcrAnormales,
          disminuirKey: teclasContaje.restarAcrAnormales
        },
        cabeza: {
          incrementarKey: teclasContaje.sumarCabezas,
          disminuirKey: teclasContaje.restarCabezas,
        },
        cola: {
          incrementarKey: teclasContaje.sumarColas,
          disminuirKey: teclasContaje.restarColas,
        },
        gotaDistal: {
          incrementarKey: teclasContaje.sumarGotaDistal,
          disminuirKey: teclasContaje.restarGotaDistal,
        },
        gotaProximal: {
          incrementarKey: teclasContaje.sumarGotaProximal,
          disminuirKey: teclasContaje.restarGotaProximal,
        },
        piezaIntermedia: {
          incrementarKey: teclasContaje.sumarPiezaIntermedia,
          disminuirKey: teclasContaje.restarPiezaIntermedia,
        },
        buenos: {
          incrementarKey: teclasContaje.sumarBuenos,
          disminuirKey: teclasContaje.restarBuenos,
        },
        cuadrosContados: {
          incrementarKey: teclasContaje.sumarCuadros,
          disminuirKey: teclasContaje.restarCuadros,
        }
      }
      yield put(openModalContajeMaquinasSuccess({tipoAnalisis, teclasContaje, isSeguimiento}))
    }
  } catch (error) {
    console.log(error)
  } finally {
  }
}

export function * watchOpenModalContajeMaquinas () {
  yield takeLatest(actionTypes.OPEN_MODAL_CONTAJE_MAQUINAS, openModalContajeMaquinas)
}

export function * closeModalContajeMaquinas ({from,values}) {
  try {
    const contajeMaquinas = yield select(state => state.contajeMaquinas)
    let data = {
        acrosomasDannados: values.acrosomasDannados,
        cabeza: values.cabeza,
        cola: values.cola,
        gotaDistal: values.gotaDistal,
        gotaProximal: values.gotaProximal,
        piezaIntermedia: values.piezaIntermedia,
        buenos: values.buenos,
        espermatozoidesContados: values.espermatozoidesContados,
        espermatozoidesContar: values.espermatozoidesContar,
        cuadrosContados: values.cuadrosContados,
        cuadrosAContar: values.cuadrosAContar,
        totalFormasAnormales: values.totalFormasAnormales,
        acrosomas: values.acrosomas
    }
    if(from == tipo.ANALISIS){
      yield put(guardarResultadoSistemaAnalisis(data, contajeMaquinas.tipoAnalisis, contajeMaquinas.isSeguimiento))
    }else if(from == tipo.CONTROL_MORFOLOGICO){
      //PASAMOS LOS DATOS AL REDUCER DE CONTROL MORFOLOGICO
      console.log('from-morfologico')
      yield put(guardarResultadoSistemaAnalisisControlMorfologico(data, contajeMaquinas.tipoAnalisis))
      
    }
    yield put(closeModalContajeMaquinasSuccess())
  } catch (error) {
    console.log(error)
  } finally {
  }
}

export function * watchCloseModalContajeMaquinas () {
  yield takeLatest(actionTypes.CLOSE_MODAL_CONTAJE_MAQUINAS, closeModalContajeMaquinas)
}
